import brandConfig from 'brandConfig'

import { isProduction } from './app/app.helpers'
import { floorNumber } from './number.helpers'

const buildReferralLink = (authId) => {
  return `${isProduction() ? brandConfig.appUrl : 'https://bwa3.qiibee.com/'}?referral=${authId}`
}

const INVITE_REFERRAL = {
  BASE_REFERRER_REWARD: 250, //X
  BASE_REFERRED_REWARD: 150, //Y
  N_MILESTONE: 5
}

const shareInviteUrl = ({ authId, symbol, referralMulti }) => {
  return `https://twitter.com/intent/tweet?text=Earn ${INVITE_REFERRAL.BASE_REFERRED_REWARD * referralMulti} ${symbol} by joining the ${brandConfig.name}. Stake%2C post%2C quest %26 shop your way to rewards — from miles%2C to crypto%2C and Apple products. 🎁 Use my invite link to get the bonus points%3A&url=${buildReferralLink(authId)}`
}

const getMilestoneInfo = ({ rewardedCount, referralMulti }) => {
  const stepSize = INVITE_REFERRAL.N_MILESTONE
  const nextMilestone =
    rewardedCount % stepSize === 0
      ? rewardedCount + stepSize
      : Math.ceil(rewardedCount / stepSize) * stepSize
  const progress = rewardedCount % stepSize
  const bonusAmount = floorNumber(
    INVITE_REFERRAL.BASE_REFERRER_REWARD * stepSize * referralMulti
  )
  return {
    nextMilestone,
    progress,
    bonusAmount
  }
}

export { buildReferralLink, INVITE_REFERRAL, shareInviteUrl, getMilestoneInfo }
